var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-layout',[_c('template',{slot:"heading"},[_c('h5',[_vm._v("パスワードのリセット")])]),_c('Reset')],2)}
var staticRenderFns = []

export { render, staticRenderFns }